var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "#18181B",
    stroke: "url(#paint0_linear_2294_1529)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-github 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.001 11.8711C18.1016 11.8711 13.3555 16.6172 13.3555 22.5166C13.3555 27.2184 16.4161 31.2105 20.6299 32.6299C21.1622 32.7186 21.3396 32.4081 21.3396 32.0976C21.3396 31.8315 21.3396 31.1661 21.3396 30.279C18.3677 30.9444 17.7468 28.8596 17.7468 28.8596C17.2588 27.6176 16.5491 27.3071 16.5491 27.3071C15.5733 26.6418 16.6378 26.6418 16.6378 26.6418C17.7024 26.7305 18.279 27.7507 18.279 27.7507C19.2105 29.3919 20.763 28.904 21.384 28.6378C21.4727 27.9281 21.7388 27.4846 22.0493 27.2184C19.6984 26.9523 17.2145 26.0208 17.2145 21.94C17.2145 20.7867 17.6137 19.8109 18.3234 19.1012C18.2347 18.8351 17.8355 17.7705 18.4121 16.2624C18.4121 16.2624 19.2992 15.9962 21.3396 17.3713C22.1824 17.1495 23.1139 17.0164 24.001 17.0164C24.8881 17.0164 25.8196 17.1495 26.6624 17.3713C28.7028 15.9962 29.5899 16.2624 29.5899 16.2624C30.1665 17.7261 29.8117 18.7907 29.6786 19.1012C30.344 19.8552 30.7875 20.7867 30.7875 21.94C30.7875 26.0208 28.3036 26.9079 25.9083 27.1741C26.3075 27.4846 26.618 28.1499 26.618 29.1257C26.618 30.5451 26.618 31.6984 26.618 32.0533C26.618 32.3194 26.7955 32.6743 27.3721 32.5855C31.586 31.2105 34.6465 27.2184 34.6465 22.5166C34.6465 16.6172 29.9004 11.8711 24.001 11.8711Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2294_1529",
    x1: 0,
    y1: 23,
    x2: 46,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95CE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.46de7c3e95fb4e27cedac3e98a830d11.svg";
export { ForwardRef as ReactComponent };